<button class="btn-govco" [class.secondary]="variant() === 'secondary'" [type]="type()"><ng-content /></button>
